export default {
  "zh-CN": {
    title: "阅读设置",
    fontSize: "字体大小",
    decreaseFont: "减小字体",
    increaseFont: "增大字体",
    lineSpacing: "行间距",
    spacingCompact: "紧凑",
    spacingComfortable: "舒适",
    spacingRelaxed: "宽松",
    background: "阅读背景",
    themePaper: "纸张",
    themeEye: "护眼",
    themeNight: "夜间"
  },
  "en-US": {
    title: "Reading settings",
    fontSize: "Font size",
    decreaseFont: "Decrease font size",
    increaseFont: "Increase font size",
    lineSpacing: "Line spacing",
    spacingCompact: "Compact",
    spacingComfortable: "Comfortable",
    spacingRelaxed: "Relaxed",
    background: "Reading background",
    themePaper: "Paper",
    themeEye: "Eye care",
    themeNight: "Night"
  },
  "ar-SA": {
    title: "إعدادات القراءة",
    fontSize: "حجم الخط",
    decreaseFont: "تصغير الخط",
    increaseFont: "تكبير الخط",
    lineSpacing: "تباعد الأسطر",
    spacingCompact: "مضغوط",
    spacingComfortable: "مريح",
    spacingRelaxed: "واسع",
    background: "خلفية القراءة",
    themePaper: "ورقي",
    themeEye: "مريح للعين",
    themeNight: "ليلي"
  }
}
